import React from 'react';
import { Outlet } from 'react-router-dom';
import {AppState} from "@Redux/store";
import {connect} from "react-redux";

const HomeLayout: React.FC<HomeLayoutProps> = ({}) => {
  return (
    <div className={`bg-game`}>
      <Outlet />
    </div>
  );
};


const mapStateToProps = (state: AppState) => ({});

const mapDispatchToProps = () => ({});


export default connect(mapStateToProps, mapDispatchToProps)(HomeLayout);

type HomeLayoutProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
